module.exports = __webpack_public_path__ + "wxMicroService/img/3.94080c70.png";